<template>
  <div style="height: 100%">
    <fdc-panel
      title="전체 (기존 Grid Sample)"
      style="height: 100%;"
    >
      <brique-grid
        style="width: 100%; height: 100%;"
        id="myGrid"
        :brique-grid-columns="columnDefs"
        @grid-ready="onGridReady"
        :default-col-def="defaultColDef"
        :row-selection="rowSelection"
        :row-data="rowData"
        :pagination="true"
        edit-type="fullRow"
        :single-click-edit="true"

        :brique-grid-is-view-pagination="true"
        :brique-grid-pagination-type="'client'"
        :brique-grid-is-view-summary="false"
        :brique-grid-is-view-total-count="true"
        :brique-grid-is-view-cud-count="true"
        :brique-grid-is-view-selected-count="true"
        :brique-grid-is-view-header="true"
        brique-grid-title="툴 목록"
        brique-grid-title-icon="data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABgAAAAYCAYAAADgdz34AAAABmJLR0QA/wD/AP+gvaeTAAACAUlEQVRIibXVTYiNYRQH8N+9cyeahsHOzGJCKY0rGRuJZuFjQ2rSrKRkEpGaTMlI2VgoH0tZDysLCQvfH5FESmxmY1YzI9+DZIqyeM80r+ve970j/nXqec/5n+f/PG/nnKcgG7PRkMP5ic85nKo4jXF8yLFxnPobgfvoTH0XsTCsmPJ3BrcqirUCVdCFG2Fd9SaVpiFwG4umwcf0bvDPMA9bMIx76M/g9gfnFTahJW/zA3iHCziCHoxgSRVuR8R6cBQX8R4HswQGsRXtWIdy3GYE61O8jRiNUy8NbnvkDuYJfMcQ7uJB+FfjMT6FPcKqiD0M7lDk5gp0x7ok+V2tqfiMsEm04a2pauyuFMiqoh84h96UbyJsEr04H9yqyOuD43iKS3heEVuOXViZtUGewBi24wpO4BoK2CAp0W3BqYl6Gu0W1mKxZExcj/Ua3MlLrndUDGOvpDThWJ15/39UpAUK6mj1OtASe/0hcBib1X7BmjA/rKkGpyH2OFQZKOM1BiTdmxZehsuSarkZNiYp3XKKV4zcgdirIy1wFvtifRV9sd6JN9iNxhS/EXsitiN8fZEL+3GGqX81Jnn6RiXt/wxfsQAfJfOnGuZgrqTKmrFCMhjb8AStpThNC16mEpvjNJldmsJJSdO9SPlmojR5gya/DzH4ImPGVKCEWRW+CXz7BZihbZ9S0CN0AAAAAElFTkSuQmCC"
        :brique-grid-is-view-import-btn="true"
        :brique-grid-is-view-export-btn="true"
        :brique-grid-refresh-function="refreshData"
        :brique-grid-is-view-restore-btn="true"
        :brique-grid-hide-toggle-columns="['country', 'sport']"
        :brique-grid-is-view-add-row-btn="true"
        :brique-grid-is-view-remove-row-btn="true"
        :brique-grid-is-view-undo-redo-btn="true"

        @brique-grid-default-on-add="defaultOnAdd"
      />
    </fdc-panel>
  </div>
</template>

<script>
export default {
  name: 'DefaultGrid',
  methods: {
    async onGridReady (params) {
      this.gridApi = params.api
      this.gridColumnApi = params.columnApi

      await this.refreshData()
    },

    defaultOnAdd (returnValue) {
      let defaultAge = () => {
        this.age++
        return this.age
      }

      Object.assign(returnValue, {
        athlete: 'Kim',
        age: defaultAge()
      })
    },

    // BriqueGrid에서 Refresh 버튼 클릭시 호출할 Function이기도 하다.
    // 반드시 Async로 작성해야 한다.
    async refreshData () {
      const updateData = (data) => {
        this.rowData = data
        this.gridApi.setRowData(data)
      }

      await fetch('https://www.ag-grid.com/example-assets/olympic-winners.json')
        .then((resp) => resp.json())
        .then((data) => updateData(data))
    }
  },
  data: function () {
    return {
      gridApi: null,
      columnApi: null,
      columnDefs: [
        { field: 'athlete', minWidth: 150, checkboxSelection: true, pinned: 'left' },
        { field: 'age', maxWidth: 90, editable: true },
        { field: 'country', minWidth: 150, editable: true },
        { field: 'year', maxWidth: 90, editable: true },
        { field: 'date', minWidth: 150, editable: true },
        { field: 'sport', minWidth: 150 },
        { field: 'gold' },
        { field: 'silver' },
        { field: 'bronze' },
        { field: 'total' }
      ],

      defaultColDef: {
        minWidth: 100,
        filter: true,
        resizable: true,
        sortable: true
      },
      rowSelection: 'multiple',
      rowData: null,

      age: 20
    }
  }
}
</script>
